import { Sensor as SensorSdk } from "coolremote-sdk";
import { ISensor } from "../models/Sensors";
import useQuery from "./useQuery";

/**
 * Fetches all sensors (aux devices) for a site. Unlike modbus units, the
 * backend already denormalizes `line` onto the sensor itself, so no
 * device-join is needed here (compare useGetSiteModbusUnitsWithDevices).
 *
 * The site-management payload only carries a `numOfSensors` count per
 * device, not the sensors themselves, so this is fetched separately.
 */
export const useGetSiteSensors = (siteId: string | undefined) => {
  return useQuery({
    queryKey: ["siteSensors", siteId],
    queryFn: async (): Promise<ISensor[]> => {
      const res: any = await SensorSdk.getSiteSensors(siteId as string);
      const dict = res?.data ?? res ?? {};
      return Object.values(dict);
    },
    onSuccess: undefined,
    onError: undefined,
    enabled: !!siteId,
  });
};
